(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("meeseOSGui", [], factory);
	else if(typeof exports === 'object')
		exports["meeseOSGui"] = factory();
	else
		root["meeseOSGui"] = factory();
})(self, () => {
return 